import React,{useContext} from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { confirm } from "react-confirm-box";
import SearchGroup from './SearchGroup';
import Update from './Update';
import { Context } from '../../context/UserContext';


const initialValues = {

    businessId: ""
}


const Index = () => {

    const context = useContext(Context);
    const { readDataByFilter: readDataGroup } = useEntityCrud('Group/GetAllGroups');
    const { statusData: changeStatus } = useEntityCrud("Group/ChangeStatus");
    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness');

    const [dataForBack, setDataForBack] = useState([]);
    const [bu, setBu] = useState("");
    const [filterBTN, setFilterBTN] = useState(false);

    const [businessList, setBusinessList] = useState([]);
    const [dataShow, setDataShow] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const navigate = useNavigate();




    useEffect(() => {
        readDataBusiness().then(res => {
            setBusinessList(res.data.result.map(item => ({ value: item.id, label: item.title, isActive: item.isActive })))
        });
    }, [])

    useEffect(() => {
         

        const postedData = {
            buisnessId: localStorage.getItem("searchDetails")
        };

        if (!postedData.buisnessId) {
            setData([])
        }

        else {
            readDataGroup(postedData).then(res => {
                 
                if (res.status === 200) {
                    if (res.data.status === false) {
                        res.data.errors.map(error => toast.error(error.message));
                    }
                    else {
                        const dd = parseInt(localStorage.getItem("searchDetails"))
                        setData(res.data.result)
                        formik.setValues({
                            ...data,
                            businessId: { value: dd, label: businessList?.find(item => item.value === dd)?.label },
                        });
                    }
                } else
                    res.data.errors.map(error => toast.error(error.message));
            })
        }

    }, [localStorage.getItem("searchDetails")])



    const onSubmit = (values) => {
        const postedData = {
            buisnessId: values.buisnessId.value,
        };
        setFilterBTN(true)

        readDataGroup(postedData).then(res => {
            if (res.status === 200) {
                if (res.data.status === false) {
                    res.data.errors.map(error => toast.error(error.message));
                }
                else {
                    setData(res.data.result)
                    if (res.data.result.length === 0) {
                        toast.error('در این کسب و کار، گروهی موجود نمی باشد');
                    }
                    navigate("/group");
                    window.localStorage.setItem("searchDetails", values.buisnessId.value);
                }
            } else
                res.data.errors.map(error => toast.error(error.message));
        })
    }


    const formik = useFormik({
        onSubmit,
        initialValues
    });






    const options = {
        render: (message, onConfirm, onCancel) => {
            return (
                <>
                    <h4 className="mb-3" style={{ fontSize: "20px" }}>{message} </h4>
                    <button className='btn btn-primary mx-1 px-4 py-2' onClick={onConfirm}> بله </button>
                    <button className='btn btn-secondary  px-4 mx-1  py-2' onClick={onCancel}> خیر </button>
                </>
            );
        }
    };


    const handleRemove = async (itemId, currentStatusId, businessId) => {
        /*         const result = await confirm(
                    currentStatusId === true ? "  آیا از غیر فعال کردن گروه مورد نظر اطمینان دارید؟ " : "  آیا از  فعال کردن گروه مورد نظر اطمینان دارید؟ ", options);
         */
        const body = {
            id: itemId,
            status: currentStatusId === true ? false : true
        }
        changeStatus(body).then(res => {
            const newData = data.map(item => {
                if (item.id === itemId)
                    return { ...item, isActive: currentStatusId === true ? false : true }
                else
                    return item
            })
            setData(newData);
            if (res.status === 200) {
                toast.success('وضعیت گروه مورد نظر با موفقیت به روزرسانی شد');
                readDataGroup(businessId).then(res0 => {
                    setData(res0.data.result)
                })
            }
            else
                data.errors?.map(error => toast.error(error.message));
        })

    }


    return (
        <>
            {/*    <div className="page-header my-0">
                <h1 class="page-title">گروه ها</h1>
            </div> */}


            <div className="card">

                <div className="card">
                    <div className="card-header p-2 py-4">
                        <h3 className="card-title">
                            {/*    <i className='fa fa-list px-1'></i> */}
                            گروه ها </h3>
                    </div>
                    <div className="card-body">
                        {context.checkHasPermission('create') ? <Link className="btn btn-primary mb-2" to="create">ایجاد گروه</Link> : ''}

                        <div class="alert alert-info" role="alert">
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-hidden="true">×</button>
                            <i class="fa fa-bell-o me-2" aria-hidden="true"></i>
                            جهت نمایش لیست گروه ها لطفا یک کسب و کار را انتخاب کنید.
                        </div>


                        <SearchGroup formik={formik} businessList={businessList} bu={bu} setBu={setBu}
                            filterBTN={filterBTN} setFilterBTN={setFilterBTN} />

                        {isLoading ?
                            <div class="lds-facebook" >
                                <div></div>
                                <div></div>
                                <div></div>
                            </div >
                            :
                            <>
                                {data?.length > 0 ? (localStorage.getItem('rl') != 3 ? <div className="table-responsive">
                                    <table className="table table-hover border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th width="1%" className='text-center' >ردیف</th>
                                                <th>عنوان کسب و کار</th>
                                                <th>عنوان گروه</th>
                                                <th>  وضعیت</th>
                                                <th>عملیات</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((item, index, i) =>
                                                <tr>
                                                    <td className='text-center'>{index + 1}</td>
                                                    <td> {businessList?.find(it => it.value === item.businessId)?.label}</td>

                                                    <td> {item.title}</td>
                                                    <td>{item.isActive ? <i className="fe fe-check text-success"></i> : <i className="fe fe-x text-danger"></i>}</td>


                                                    <td>
                                                        {context.checkHasPermission('update') ? <Link to={`update/${item.id}`} className="btn btn-icon mb-0 btn-primary  mx-1">
                                                            <i className="fe fe-edit-2"></i>
                                                        </Link> : ''}
                                                        {/*             <button
                                                            className="btn btn-danger d-inline m-1 btn-icon d-inline"
                                                            type="button"
                                                            variant="danger"
                                                            onClick={() => handleRemove(item.id, item.isActive, item.businessId)}
                                                        >
                                                            {item.isActive === true ?
                                                                <i className="fe fe-x text-white"></i>
                                                                :
                                                                <i className="fe fe-check text-white"></i>
                                                            }
                                                        </button>
 */}
                                                        {context.checkHasPermission('delete') ? (item.isActive ?
                                                            <button onClick={() => handleRemove(item.id, item.isActive, item.businessId)} className="btn btn-icon mb-0 btn-danger" title="غیرفعال سازی">
                                                                <i className="fe fe-x"></i>
                                                            </button>
                                                            : <button onClick={() => handleRemove(item.id, item.isActive, item.businessId)} className="btn btn-icon mb-0 btn-success" title="فعال سازی">
                                                                <i className="fe fe-check"></i>
                                                            </button>) : ''}

                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    </div> : <div className="row">
                                    {data.map((item, index) => (
                                        <div className="col-md-6" key={index}>
                                            <div className="card custom-border-1">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <p>کسب و کار: {businessList?.find(it => it.value === item.businessId)?.label}</p>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <p>عنوان گروه: {item.title}</p>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <p>وضعیت: {item.isActive ? <span className="text-success">فعال</span> : <span className="text-danger">غیرفعال</span>}</p>
                                                    </div>
                                                </div>
                                            <div className="operation-btn-group">
                                                {context.checkHasPermission('update') ? <Link to={`update/${item.id}`} className="btn btn-icon mb-0 btn-primary  mx-1">
                                                    <i className="fe fe-edit-2"></i>
                                                </Link> : ''}
                                                {context.checkHasPermission('delete') ? (item.isActive ?
                                                    <button onClick={() => handleRemove(item.id, item.isActive, item.businessId)} className="btn btn-icon mb-0 btn-danger">
                                                        <i className="fe fe-x"></i>
                                                    </button>
                                                    : <button onClick={() => handleRemove(item.id, item.isActive, item.businessId)} className="btn btn-icon mb-0 btn-success">
                                                        <i className="fe fe-check"></i>
                                                </button>) : ''}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                </div>) :
                                    ""
                                }

                            </>
                        }

                    </div>
                </div>
            </div>
        </>
    );
}

export default Index;